import { FC, useState } from 'react'
import dynamic from 'next/dynamic'

const PopupFAQ = dynamic(() => import('components/popups/popup-faq/popup-faq'))

import { STATIC_URL } from 'constants/data'
import { A_wa_openFAQ } from 'utils/analytics/webinars/webinat_active'

import styles from './button-faq.module.scss'

const questionURL = `url(${STATIC_URL}/webinar/icon_faq.svg)`

const ButtonFAQ: FC = () => {
  const [isShowFAQ, setShowFAQ] = useState(false)

  const handleClick = () => {
    setShowFAQ(!isShowFAQ)
    A_wa_openFAQ()
  }

  const closePopup = () => setShowFAQ(false)

  return (
    <>
      <button
        className={styles.buttonWarp}
        onClick={handleClick}
        style={{
          backgroundImage: questionURL,
        }}
      />
      {isShowFAQ && <PopupFAQ handleShowFAQ={closePopup} />}
    </>
  )
}

export default ButtonFAQ
